/**
 * @graph-stack ac-mens-hub
 * @graph-domain Engineering
 * @graph-business Hub 権限管理 API クライアント。ロール CRUD、ユーザーロール管理、現在ユーザー権限取得を行う。
 * @graph-connects /permissions/me [calls] 現在ユーザー権限
 * @graph-connects /permissions/roles [calls] ロール CRUD
 * @graph-connects /permissions/user-roles [calls] ユーザーロール管理
 */

import { request } from './api.js';
import type {
  UserPermissionsResponse,
  RoleListResponse,
  Role,
  CreateRoleInput,
  UpdateRoleInput,
  UserRoleListResponse,
  SetUserRolesInput,
} from '../types/permissions.js';

/** @graph-connects none */
export const permissionsApi = {
  getMyPermissions: (): Promise<UserPermissionsResponse> => request('/permissions/me'),
  listRoles: (): Promise<RoleListResponse> => request('/permissions/roles'),
  createRole: (input: CreateRoleInput): Promise<Role> =>
    request('/permissions/roles', { method: 'POST', body: JSON.stringify(input) }),
  updateRole: (id: string, input: UpdateRoleInput): Promise<Role> =>
    request(`/permissions/roles/${id}`, { method: 'PUT', body: JSON.stringify(input) }),
  deleteRole: (id: string): Promise<{ success: boolean }> =>
    request(`/permissions/roles/${id}`, { method: 'DELETE' }),
  listUserRoles: (): Promise<UserRoleListResponse> => request('/permissions/user-roles'),
  setUserRoles: (input: SetUserRolesInput): Promise<{ success: boolean }> =>
    request('/permissions/user-roles', { method: 'PUT', body: JSON.stringify(input) }),
};
